<div class="wrap">
  <div class="validation_mail">
    <div class="check">
      <span class="icon-line line-tip"></span>
      <span class="icon-line line-long"></span>
      <div class="icon-circle"></div>
      <div class="icon-fix"></div>
    </div>
  </div>
  <h1>Inscription terminée</h1>
  <p>Votre inscription a bien été finalisée</p>
  <p class="redirection">Redirection en cours <span>.</span><span>.</span><span>.</span></p>
</div>